<template>
  <div class="alert" role="alert">
    <div class="media text-left">
      <Component :is="icon" :height="iconSize" class="ml-0 mr-3" v-if="icon" />
      <div class="media-body font-weight-normal align-self-center">
        <p :class="{
            'mb-1': !!$slots.default,
            'mb-0': !$slots.default
          }" v-if="title">
          <strong v-html="title" v-if="!titleLink"></strong>
          <router-link v-else :to="{ name: titleLink }" class="alert-link"><span v-html="title"></span></router-link>
        </p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    iconSize: {
      type: Number,
      default: 24
    },
    title: String,
    titleLink: String
  }
}
</script>
